import { Bell } from 'lucide-react';

export interface Notification {
  id: string;
  title: string;
  notification: string;
  time: string;
  unread: boolean;
}

interface notificationProps {
  notifications?: Notification[];
}

export function RecentNotifications({ notifications }: notificationProps) {
  const defaultMessages: Notification[] = [
    {
      id: '1',
      title: 'Sarah Johnson',
      notification: 'When can we schedule the final walkthrough?',
      time: '1h ago',
      unread: true
    },
    {
      id: '2',
      title: 'Michael Chen',
      notification: 'The materials have been delivered. Ready to proceed.',
      time: '3h ago',
      unread: true
    },
    {
      id: '3',
      title: 'John Smith',
      notification: 'Thank you for the update on the kitchen timeline.',
      time: '1d ago',
      unread: false
    }
  ];

  const displayMessages = notifications ?? defaultMessages;
  const unreadCount = displayMessages.filter(m => m.unread).length;

  const getDisplayTitle = (message: Notification) => {
    if (message.title && message.title.toLowerCase() !== 'notification') {
      return message.title;
    }

    const body = message.notification.toLowerCase();
    if (body.includes('license')) return 'License verification needs attention';
    if (body.includes('photo id') || body.includes('identity')) return 'Identity verification needs attention';
    if (body.includes('message')) return 'New message';
    return 'Account update';
  };

  return (
    <section className="dashboard-panel notifications-panel bg-white border border-gray-200 rounded-xl p-6 shadow-sm" aria-labelledby="recent-notifications-title">
      <div className="flex items-center justify-between mb-5">
        <h3 id="recent-notifications-title" className="font-[500] text-gray-900 tracking-tight">Notifications</h3>
        {unreadCount > 0 && (
          <span className="notifications-panel__count">
            {unreadCount} unread
          </span>
        )}
      </div>
      <ul className="notifications-panel__list space-y-3">
        {displayMessages.map((message) => (
          <li
            key={message.id}
            className={`notifications-panel__item ${message.unread ? 'notifications-panel__item--unread' : ''}`}
          >
            <div className="flex items-start gap-3">
              <div className="notifications-panel__icon" aria-hidden="true">
                <Bell className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-3 mb-1.5">
                  <span className="notifications-panel__title">
                    {getDisplayTitle(message)}
                  </span>
                  <span className="notifications-panel__time">{message.time}</span>
                </div>
                <div className="notifications-panel__message">
                  {message.notification}
                </div>
              </div>
              {message.unread && (
                <span className="notifications-panel__unread-dot" aria-label="Unread" />
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
